import { call, put, select } from "redux-saga/effects";
import api, { makeOptions } from "@/services/api";
import toastify from "@/services/toastify";
import CreateEmpresaActions from "@/store/ducks/empresas/create";

const getAuthData = state => state.auth.data;

export function* create(action) {
  try {
    const { data, history, pathname } = action;
    const authData = yield select(getAuthData);
    const { data: retorno } = yield call(
      api.post,
      `empresas/cadastro`,
      data,
      makeOptions(authData)
    );

    if (retorno.success) {
      yield put(CreateEmpresaActions.createEmpresaSuccess(retorno.data));

      if (Number(data.escola) === 1) {
        toastify("Escola criada com sucesso");
      } else {
        toastify("Empresa criada com sucesso");
      }

      if (pathname !== undefined) {
        history.push(pathname);
      } else {
        history.push("/login");
      }

    } else {
      yield put(CreateEmpresaActions.createEmpresaFailure(retorno.errors));
      // exibindo um toast para cada erro
      [...Object.keys(retorno.errors)].forEach(e => {
        toastify(retorno.errors[e][0], "error");
      });
    }
  } catch (e) {
    yield put(
      CreateEmpresaActions.createEmpresaFailure({
        api_failure: "Não foi possível se comunicar com a API",
      })
    );
  }
}
